module.exports = "\n<i-button @click=\"$emit('click')\" :type=\"type\" :shape=\"shape\" :style='editorStyle' :id=\"id\">{{ innerText }}</i-button>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/components/button/src/index.vue
// module id = 2319
// module chunks = 38